import { Card, CardContent, Stack, Typography } from '@mui/material';
import LoginLogo from '@/assets/images/login_logo.png';

interface AuthCardProps {
	title: string;
	message: string;
	cardContentStyle?: React.CSSProperties;
}

export default function AuthCard(
	props: React.PropsWithChildren<AuthCardProps>
) {
	return (
		<>
			<Stack width='480px'>
				<Card>
					<CardContent
						sx={{ flex: 1, padding: '16px 24px' }}
						style={props.cardContentStyle}
					>
						<img
							src={LoginLogo}
							style={{ display: 'block', width: '164px', height: '41px' }}
						/>
						<Typography
							fontSize='20px'
							variant='bold'
							marginTop='24px'
							whiteSpace='nowrap'
							display={'block'}
						>
							{props.title}
						</Typography>
						<Typography
							fontSize='body2'
							marginTop='7px'
							color='common.neutral50'
						>
							{props.message}
						</Typography>
						{props.children}
					</CardContent>
				</Card>
			</Stack>
		</>
	);
}
